import React from 'react';
import { Spinner } from '@/components/shared/Spinner';

import styled from 'styled-components';

export const CenteredLoader: React.FC = () => {
  return (
    <Wrapper>
      <Spinner size="small" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1000;
`;
